import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export const useMutationSendSMSToMembers = ({ api }: { api: ApiType }) => {
  return useMutation({
    mutationFn: async (
      payload: Parameters<ApiType["smsApi"]["sendSMSToMembers"]>[0],
    ) => {
      const { data } = await api.smsApi.sendSMSToMembers(payload);
      return data;
    },
  });
};
